import React from "react";
import Button from "../../../../../common/components/Forms/Button/Button";

interface IQuoteTableViewSwitcherContentProps {
    viewSwitcherText: string;
    onClickSwitchView: () => void;
}

const QuoteTableViewSwitcherContent: React.FC<IQuoteTableViewSwitcherContentProps> = (
    props
) => {
    const { viewSwitcherText, onClickSwitchView } = props;

    return (
        <Button component="button" size="xs" onClick={onClickSwitchView}>
            {viewSwitcherText}
        </Button>
    );
};

export default QuoteTableViewSwitcherContent;
